// extracted by mini-css-extract-plugin
export default {"list":"PublishApartmentModal_list__FUZUt"};